import { ResellerStore } from '@/app/features/reseller';
import { finalize, catchError, throwError } from 'rxjs';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { inject, signal, Component, WritableSignal } from '@angular/core';
import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AlertService } from '@/app/core/services/alert/alert.service';

import { InputComponent } from '@/app/shared/components/ui/input/input.component';
import { ButtonComponent } from '@/app/shared/components/ui/button/button.component';
import { FormGroupComponent } from '@/app/shared/components/form/form-group/form-group.component';
import {
  DialogComponent,
  BaseDialogComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogContentComponent,
} from '@/app/shared/components/ui/dialog';

import { showBadRequestError } from '@/app/shared/helpers/errors.helper';
import { isInvalid, ValidationMessage } from '@/app/shared/helpers/validations.helper';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [
    DialogComponent,
    DialogHeaderComponent,
    DialogContentComponent,
    DialogFooterComponent,
    ButtonComponent,
    TranslatePipe,
    FormGroupComponent,
    FormsModule,
    InputComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './become-reseller-modal.component.html',
  styleUrl: './become-reseller-modal.component.scss',
})
export class BecomeResellerModalComponent extends BaseDialogComponent<any, boolean> {
  protected readonly ValidationMessage = ValidationMessage;

  protected readonly isInvalid = isInvalid;

  private readonly resellerStore: ResellerStore = inject(ResellerStore);

  private readonly translateService: TranslateService = inject(TranslateService);

  protected form: FormGroup;

  protected isLoading: WritableSignal<boolean> = signal(false);

  constructor(
    private readonly alertService: AlertService,
    private readonly formBuilder: FormBuilder,
  ) {
    super();

    this.dialogRef.updateSize('425px');

    this.form = this.formBuilder.group({
      message: [''],
    });
  }

  protected sendRequest() {
    this.isLoading.set(true);

    this.resellerStore
      .sendBecomeResellerRequest(this.form.value.message ?? '')
      .pipe(
        catchError((error) => {
          showBadRequestError(error, this.alertService);

          return throwError(() => error);
        }),
        finalize(() => this.isLoading.set(false)),
      )
      .subscribe(() => {
        this.alertService.success(
          this.translateService.instant('shared.components.become-reseller-modal.request.alert.success'),
        );

        this.dialogRef.submit(true);
      });
  }
}
